const FALLBACK_MESSAGE = 'Ocorreu um erro inesperado.'

function fromRecord(value: Record<string, unknown>): string {
  const candidates = ['message', 'error', 'detail', 'details', 'msg', 'statusText', 'reason']
  for (const key of candidates) {
    const raw = value[key]
    if (typeof raw === 'string' && raw.trim()) return raw.trim()
    if (raw && typeof raw === 'object') {
      const nested = fromRecord(raw as Record<string, unknown>)
      if (nested !== FALLBACK_MESSAGE) return nested
    }
  }
  const status = value.status ?? value.code
  if (typeof status === 'number' || (typeof status === 'string' && status.trim())) {
    return `Falha na operação (código ${status}).`
  }
  return FALLBACK_MESSAGE
}

/**
 * Converte qualquer valor lançado numa mensagem legível.
 * Evita registos inúteis do tipo "{}" quando o erro não é uma instância de Error.
 */
export function describeError(error: unknown): string {
  if (!error) return FALLBACK_MESSAGE
  if (typeof error === 'string') return error.trim() || FALLBACK_MESSAGE
  if (error instanceof Error) return error.message?.trim() || error.name || FALLBACK_MESSAGE
  if (typeof error === 'object') return fromRecord(error as Record<string, unknown>)
  return String(error)
}

/**
 * Registo de erros com contexto e mensagem já normalizada,
 * mantendo o valor original para inspeção na consola.
 */
export function logError(scope: string, error: unknown) {
  console.error(`[BONITAFM] ${scope}: ${describeError(error)}`, error)
}
